module.exports = __webpack_public_path__ + "static/media/feature_decision_support.f8ef9d72.png";